"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runLogoutIframe = exports.runLoginIframe = void 0;
const configs_constants_1 = require("../constants/configs.constants");
const TIMEOUT_MS = 15000;
const generalIframeFn = (urls, messageName, dataValidationFn, debugLevel = 'EXCESSIVE') => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        /**
         * Open the iframe and hide it
         */
        const iframe = window.document.createElement('iframe');
        iframe.setAttribute('width', '0');
        iframe.setAttribute('height', '0');
        iframe.style.display = 'none';
        if (debugLevel === 'EXCESSIVE')
            console.log('Created iFrame successfully...');
        /**
         * Set up a timeout to make sure we fail the auth attempt at some point
         */
        const timeoutSetTimeoutId = setTimeout(() => {
            // Clean up and return
            window.removeEventListener('message', iframeEventHandler, false);
            window.document.body.removeChild(iframe);
            if (debugLevel === 'EXCESSIVE')
                console.log('Fetching token took too long... aborting');
            reject(new Error('TIMEOUT'));
        }, TIMEOUT_MS);
        /**
         * Define the message event handler
         */
        const iframeEventHandler = (e) => {
            if (e.origin !== urls.AUTH_URL || e.data.type !== messageName) {
                if (debugLevel === 'EXCESSIVE') {
                    console.log('Message origin or type wrong, ignoring...');
                    console.log(e);
                }
                return;
            }
            if (debugLevel === 'EXCESSIVE') {
                console.log('[SUCCESS] Message received with correct origin and type...');
                console.log(e);
            }
            clearTimeout(timeoutSetTimeoutId);
            window.removeEventListener('message', iframeEventHandler, false);
            window.document.body.removeChild(iframe);
            const validData = dataValidationFn(e);
            if (debugLevel === 'EXCESSIVE')
                console.log(`Valid data: ${validData}`);
            validData ? resolve(e.data.response) : reject(new Error(e.data.response.error));
        };
        /**
         * Event handler and mounting point for once the iframe has loaded
         */
        iframe.onload = () => {
            if (!iframe.contentWindow) {
                // Cleanup
                clearTimeout(timeoutSetTimeoutId);
                window.removeEventListener('message', iframeEventHandler, false);
                window.document.body.removeChild(iframe);
                if (debugLevel === 'EXCESSIVE')
                    console.log('iFrame error, no contentWindow');
                // Reject
                reject(new Error('NO_CONTENT_WINDOW'));
            }
            else {
                if (debugLevel === 'EXCESSIVE')
                    console.log('iFrame navigated to correct page, posting message:', messageName);
                iframe.contentWindow.postMessage({ type: messageName }, '*');
            }
        };
        window.addEventListener('message', iframeEventHandler, false);
        if (debugLevel === 'EXCESSIVE')
            console.log('Added eventListener to iFrame');
        window.document.body.appendChild(iframe);
        if (debugLevel === 'EXCESSIVE')
            console.log('Appended iFrame to document');
        iframe.setAttribute('src', `${urls.AUTH_URL}/authorization.html`);
        if (debugLevel === 'EXCESSIVE')
            console.log(`Navigated to authorization page: ${urls.AUTH_URL}/authorization.html`);
    });
});
const runLoginIframe = (urls) => generalIframeFn(urls, configs_constants_1.AUTH_MESSAGE_NAME, (e) => { var _a; return !!(((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.response) && !e.data.response.error); });
exports.runLoginIframe = runLoginIframe;
const runLogoutIframe = (urls) => generalIframeFn(urls, configs_constants_1.LOGOUT_MESSAGE_NAME, (e) => { var _a, _b, _c; return !!(((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.response) && ((_c = (_b = e === null || e === void 0 ? void 0 : e.data) === null || _b === void 0 ? void 0 : _b.response) === null || _c === void 0 ? void 0 : _c.status) === 'SUCCESS'); });
exports.runLogoutIframe = runLogoutIframe;
